<template>
    <div>
        <PageMenu></PageMenu>
        <div id="app-main">
            <div class="col-12">
                <div class="section-header no-icon">
                    <h1>Zamówienie usługi transportowej</h1>
                </div>
            </div>
            <finished-order-popup
                v-show="showFinishedOrderPopup"
                @setFinishedOrderPopup="setFinishedOrderPopup"
            ></finished-order-popup>
            <div class="col-8">
                <final-step :payuUrl="payuUrl" v-show="false"></final-step>

                <div class="container-new desktop-order-form">
                    <step-bar :step="orderStep"></step-bar>
                    <!-- kroki -->
                    <vendor-agata-location-list
                        :warehouseError="warehouseError"
                        @setVendorWarehouse="setVendorWarehouse"
                        v-show="orderStep == 1"
                    ></vendor-agata-location-list>

                    <delivery-type-box
                        v-show="
                            false &&
                            orderData.warehouse &&
                            orderData.warehouse.ID == 9
                        "
                        :delivery="orderData.delivery"
                        :step="orderStep"
                    ></delivery-type-box>
                    <delivery-address-section
                        @setCustomerLocation="setCustomerLocation"
                        @setAddressError="setAddressError"
                        :zone="orderData.delivery.zone"
                        :step="orderStep"
                        :warehouse="orderData.warehouse"
                        :address="orderData.address"
                        :addressError="addressError"
                        v-show="orderStep == 2"
                    ></delivery-address-section>
                    <address-map
                        @setDelivDistance="setDelivDistance"
                        v-show="orderStep == 2"
                        :step="orderStep"
                        :address="orderData.address"
                        :warehouse="orderData.warehouse"
                    ></address-map>
                    <parcels-box
                        @parcelsValid="parcelsValid"
                        :step="orderStep"
                        v-show="orderStep == 3"
                        :orderParts="orderData.parts"
                        @addPart="addPart"
                        @removePart="removePart"
                    ></parcels-box>
                    <order-details
                        v-show="orderStep == 4"
                        :warehouse="orderData.warehouse"
                        :orderParts="orderData.parts"
                        :address="orderData.address"
                        @setDeliveryOptionsError="setDeliveryOptionsError"
                        @setDeliveryCost="setDeliveryCost"
                        @addPart="addPart"
                        @setOrderStep="setOrderStep"
                        @setDelivDate="setDelivDate"
                        @setDelivDistance="setDelivDistance"
                        @setCustomerLocation="setCustomerLocation"
                        @setDelivTimePeriod="setDelivTimePeriod"
                        @removePart="removePart"
                    ></order-details>
                    <order-summary
                        :step="orderStep"
                        @setOrderStep="setOrderStep"
                        :orderData="orderData"
                        v-show="orderStep == 5 || orderStep == 6"
                        @setCustomerDataError="setCustomerDataError"
                    ></order-summary>

                    <!-- kroki -->
                    <order-nav-section
                        @setFinishedOrderPopup="setFinishedOrderPopup"
                        @pay="pay"
                        @createOrder="createOrder"
                        @setOrderStep="setOrderStep"
                        :step="orderStep"
                    ></order-nav-section>
                </div>
            </div>
            <div class="col-4">
                <order-price-section
                    v-show="orderStep >= 3"
                    @changeMannualyDelivCost="changeMannualyDelivCost"
                    :delivery="orderData.delivery"
                    :step="orderStep"
                ></order-price-section>
                <img class="instruction-img" src="/images/instr-img.png" />
                <right-box
                    :step="orderStep"
                    v-show="orderStep != 6"
                ></right-box>
                <delivery-point-section
                    :step="orderStep"
                    :orderData="orderData"
                    v-show="false"
                ></delivery-point-section>
                <first-step-map v-show="orderStep == 1"></first-step-map>
                <summary-box
                    v-show="orderStep > 1"
                    :step="orderStep"
                    :orderData="orderData"
                ></summary-box>
                <parcels-summary-box
                    v-show="orderStep > 3"
                    :step="orderStep"
                    :orderParts="orderData.parts"
                ></parcels-summary-box>
                <help-box :step="orderStep" v-show="orderStep === 6"></help-box>
            </div>

            <!-- dodatkowy element -->
            <div class="col-12" v-show="!payuUrl">
                <CallCenterMap
                    v-show="false"
                    :delivery="orderData.delivery"
                    :deliveryAddress="orderData.address"
                    :warehouse="orderData.warehouse"
                    :division="orderData.warehouse"
                ></CallCenterMap>
            </div>
        </div>
        <PageFooter></PageFooter>
    </div>
</template>

<script>
import StepBar from "./StepBar";
import VendorAgataLocationList from "./VendorAgataLocationList";
import OrderNavSection from "./OrdeNavSection";
import OrderPriceSection from "./OrderPrice";
import OrderHelpSection from "./HelpSection";
import DeliveryPointSection from "./DeliveryPointSection";
import DeliveryAddressSection from "./DeliveryAddressSection";
import OrderDetails from "./OrderDetails";
import OrderSummary from "./OrderSummary";
import CallCenterMap from "./CallCenterMap";
import FinalStep from "./FinalStep";
import FirstStepMap from "./FirstStepMap";
import AddressMap from "./AddressMap";
import RightBox from "./RightBox";
import SummaryBox from "./SummaryBox";
import ParcelsBox from "./ParcelsBox";
import ParcelsSummaryBox from "./ParcelsSummaryBox";
import DeliveryTypeBox from "./DeliveryTypeBox";
import HelpBox from "./HelpBox";
import PayuForm from "./PayuForm";
import FinishedOrderPopup from "./FinishedOrderPopup";
import PageMenu from "./PageMenu";
import PageFooter from "./PageFooter";

export default {
    components: {
        PageMenu,
        PageFooter,
        DeliveryAddressSection,
        DeliveryPointSection,
        OrderHelpSection,
        OrderPriceSection,
        OrderNavSection,
        OrderDetails,
        VendorAgataLocationList,
        StepBar,
        OrderSummary,
        CallCenterMap,
        FinalStep,
        FirstStepMap,
        AddressMap,
        RightBox,
        SummaryBox,
        ParcelsBox,
        ParcelsSummaryBox,
        DeliveryTypeBox,
        HelpBox,
        PayuForm,
        FinishedOrderPopup,
    },
    name: "hello",
    data() {
        return {
            isLoading: false,
            //payMethodsList: [], //TEST
            showFinishedOrderPopup: false,
            deliveryWithoutCarry: 15, // bez wniesienia
            testObj: null, // TODO - usunac po testach
            orderStep: 1,
            warehouseError: false,
            addressError: false,
            customerDataError: false,
            payuUrl: "",
            orderData: {
                orderNumber: "",
                order: {
                    extOrderId: "",
                    totalAmount: "",
                    language: "pl",
                    notifyUrl: "",
                    customerIp: "",
                    currencyCode: "",
                    continueUrl: "",
                    description: "",
                    payMethod: "",
                    buyer: {
                        email: "",
                        phone: "",
                        firstName: "",
                        lastName: "",
                    },
                },
                remarks: "",
                acceptPayuRules: true,
                warehouse: null,
                customer: {
                    FirstName: "Imię",
                    LastName: "Nazwisko",
                    Email: "E-mail",
                    MobilePhone: "Nr telefonu komórkowego",
                },
                address: {
                    Street: "",
                    StreetNo: "",
                    ApartmentNo: "",
                    PostalCode: "",
                    FloorNo: "",
                    City: "",
                    Lat: "",
                    Lng: "",
                },
                mapData: {},
                delivery: {
                    cost: "",
                    distance: "",
                    distanceOutOfZone: "",
                    timePeriod: "08:00 - 20:00", // domyślnie
                    serviceName: "Transport",
                    zoneName: "",
                    date: "",
                    withCarry: 1,
                    zone: {
                        Symbol: "",
                        ID: "",
                    },
                    costParts: {
                        inZoneDelivery: 0,
                        paidDistanceDelivery: 0,
                    },
                },
                invoice: {
                    CompanyName: "",
                    Street: "",
                    StreetNo: "",
                    ApartmentNo: "",
                    PostalCode: "",
                    NIP: "",
                    City: "",
                },
                parts: [],
                division: "",
                Calculation: {
                    InZoneDelivery: 0,
                    PaidDistanceDelivery: 0,
                },
            },
            urls: {
                createOrder: "/api/order/create",
                sendOrder: "/api/sendOrder",
                getDeliveryPrice: "/api/delivery/test/getDelivPrice/",
            },
        };
    },
    mounted: function () {
        var self = this;
        Event.$on("kmOutZone", function (val) {
            //console.log('kmOutZone' + val);
            self.orderData.delivery.distanceOutOfZone = val;
        });

        Event.$on("changePartValue", function (sum) {
            //console.log('changePartValue' + sum);
            self.getDeliveryCost(sum);
        });

        Event.$on("changePartWeight", function (sum) {
            //console.log('changePartWeight' + sum);
            self.getDeliveryCost(sum);
        });

        Event.$on("directionServiceResults", function (points) {
            //console.log('MAMMMMMMMMMMMMMM')
        });
    },
    methods: {
        getFakePayments: function () {
            var self = this;
            self.$http.get("/api/fakePaymentsList/").then(function (response) {
                if (response.data.paymentsList) {
                    self.payMethodsList = response.data.paymentsList;
                } else {
                    //@TODO - jesli nie da sie obliczyc ceny
                }
            });
        },

        setFinishedOrderPopup: function (v) {
            this.showFinishedOrderPopup = v;
        },

        preparePayu: function (oData) {
            // TODO - dodac pozostale dane
            this.orderData.orderNumber = oData.OrderNumber;
            this.orderData.order.extOrderId = oData.extOrderId;
            this.orderData.order.totalAmount =
                this.orderData.delivery.cost * 100;
            this.orderData.order.language = 0;
            this.orderData.order.currencyCode = oData.currencyCode;
            this.orderData.order.notifyUrl = oData.notifyUrl;
            this.orderData.order.continueUrl = oData.continueUrl;
            this.orderData.order.customerIp = oData.customerIp;
            this.orderData.order.OrderNumber = oData.OrderNumber;
            this.orderData.order.OrderID = oData.OrderID;

            this.orderData.order.buyer.email = this.orderData.customer.Email;
            this.orderData.order.buyer.firstName = this.orderData.customer.FirstName;
            this.orderData.order.buyer.lastName = this.orderData.customer.LastName;
            this.orderData.order.buyer.phone = this.orderData.customer.MobilePhone;
            this.orderData.order.description =
                "Dostawa z wniesieniem " + oData.OrderNumber;
            this.orderData.order.pokId = this.$store.state.pokId;
        },

        pay: function () {
            var self = this;
            var valid = true;
            var oData = JSON.parse(JSON.stringify(self.orderData.order));
            delete oData.buyer;

            return self.$http
                .post(self.urls.sendOrder, {
                    order: oData,
                    buyer: self.orderData.order.buyer,
                })
                .then(function (response) {
                    if (!_.isEmpty(response.data)) {
                        if (!_.isEmpty(response.data.redirectUrl)) {
                            console.log(response.data.redirectUrl);
                            window.location.href = response.data.redirectUrl;
                        }
                    }
                });
        },

        createOrder: function () {
            var self = this;
            self.orderData.division = this.$store.state.divisionName;
            self.orderData.divisionSymbolExternal = this.$store.state.divisionSymbolExternal;
            self.orderData.address.Lat = self.$store.state.deliveryAddress.Lat;
            self.orderData.address.Lng = self.$store.state.deliveryAddress.Lng;

            // koszty
            self.orderData.Calculation.InZoneDelivery =
                self.$store.state.deliveryCost.inZoneDelivery;
            self.orderData.Calculation.PaidDistanceDelivery =
                self.$store.state.deliveryCost.paidDistanceDelivery;
            // odleglosci

            if (
                self.$store.setOrderCreated === true ||
                self.isLoading === true
            ) {
                return;
            }
            self.isLoading = true;
            // SALES - dopisac
            console.log(self.orderData);

            var url = "";
            if (self.$store.state.orderType === "doubleOrder") {
                url = self.$store.state.urls.createDoubleOrder;
            } else if (self.$store.state.orderType === "orderToPay") {
                url = self.$store.state.urls.createOrderToPay;
            }

            self.$http
                .post(self.urls.createOrder, { orderData: self.orderData })
                .then(function (response) {
                    if (response.data.status === "ok") {
                        self.$store.commit("setOrderCreated", true);
                        self.payuUrl = response.data.payuUrl;
                        // TODO SEARCH_NOW
                        self.preparePayu(response.data);
                        self.orderStep = 6;
                        Event.$emit("orderStep", 6);
                    } else {
                        alert("Przepraszamy, nie można utworzyć zlecenia");
                    }
                    self.isLoading = false;
                });
        },

        parcelsValid: function (v) {
            if (v === true) {
                this.setOrderStep(4, v);
                console.log("parcels ok =- strartt ");
            } else {
                console.log("parcels BAD =- strartt ");
            }
        },

        changeMannualyDelivCost: function (cost) {
            this.orderData.delivery.cost = cost;
        },

        setDeliveryCost: function (d) {
            var delivCost = parseFloat(d);
            if (this.orderData.delivery.withCarry === 0) {
                delivCost = delivCost - this.deliveryWithoutCarry;
            }
            this.orderData.delivery.cost = delivCost;
        },

        setCustomerLocation: function (custLocation) {
            Event.$emit("mapSetCustomLocation", custLocation);
        },

        setDelivDistance: function (d) {
            console.log("setDelivDistance");
            if (d) {
                this.orderData.delivery.distance = d;
            }
        },

        setAddressError: function (v) {
            this.addressError = v;
            if (v === false) {
                this.orderStep = 3;
                this.getDeliveryZone();
            }
        },

        setDelivTimePeriod: function (t) {
            this.orderData.delivery.timePeriod = t;
        },

        setDelivDate: function (d) {
            this.orderData.delivery.date = d;
        },

        removePart: function (index) {
            //var p = _.find(this.orderData.parts, {ordNumber: part.ordNumber});
            //this.testObj = p;
            //let index = this.orderData.parts.indexOf(p)
            this.orderData.parts.splice(index, 1);
            //if (p) {
            //this.orderData.parts.splice(p);
            //}
        },

        addPart: function (newOrderPart) {
            var ov =
                newOrderPart.ordValue === "Wpisz wartość zamówienia" ||
                newOrderPart.ordValue === ""
                    ? 0
                    : newOrderPart.ordValue;
            var newPart = {
                ordNumber: newOrderPart.ordNumber,
                ordValue: ov,
            };
            console.log(newPart);
            this.orderData.parts.push(newPart);
        },

        setOrderStep: function (v, params) {
            this.warehouseError = false;
            console.log("orderStep" + v);
            if (v == 1) {
                this.orderStep = 1;
            } else if (v == 2) {
                if (this.orderData.warehouse == null) {
                    this.warehouseError = true;
                    return;
                } else {
                    this.orderStep = 2;
                }
            } else if (v == 3) {
                Event.$emit("orderStep", 3);
            } else if (v == 4) {
                if (params === true) {
                    Event.$emit("orderStep", 4);
                    this.orderStep = 4;
                } else {
                    Event.$emit("orderStep", 4);
                    Event.$emit("validateParts");
                }
            } else if (v == 5) {
                Event.$emit("orderStep", 5);
                if (!_.isEmpty(this.orderData.delivery.date)) {
                    this.orderStep = 5;
                }
            } else if (v == 6) {
                Event.$emit("checkCustomerData");
            }
        },

        getDeliveryZone: function () {
            var self = this;
            self.$http
                .get(
                    "/api/delivery/getZone/" + self.orderData.address.PostalCode
                )
                .then(function (response) {
                    if (response.data.status == "ok") {
                    } else {
                        //@TODO - jesli nie da sie obliczyc ceny
                    }
                });
        },

        getDeliveryCost: function (sum) {
            var self = this;

            if (this.orderData.warehouse === null) {
                return;
            }

            var partsValueSum = this.getPartsValueSum();
            var partsWeightSum = this.getPartsWeightSum();

            var params = {
                kmDistance: this.orderData.kmDistance,
                kmOutsideZone: this.orderData.delivery.distanceOutOfZone,
                divisionId: this.orderData.warehouse.ID,
                zone: this.orderData.delivery.zone,
                postalCode:
                    this.orderData.address && this.orderData.address.PostalCode,
                orderValue: partsValueSum,
                orderWeight: partsWeightSum,
            };

            self.$http
                .post(self.urls.getDeliveryPrice, { params })
                .then(function (response) {
                    if (response.data.status === "ok") {
                        self.orderData.delivery.cost = response.data.cost;
                        self.$store.commit(
                            "setDeliveryCostInZone",
                            response.data.costParts.inZoneDelivery
                        );
                        self.$store.commit(
                            "setDeliveryCostPaidDistance",
                            response.data.costParts.paidDistanceDelivery
                        );
                        // store
                        //console.log('+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++');
                        //alert(response.data.cost);
                        self.$emit("setDeliveryCost", response.data.cost);
                    }
                });

            //@TODO - dodac parametry1111111
            //                self.$http.post("/api/delivery/getDeliveryData", {delivParams: params}).then(function (response) {
            //                    if (response.data.status == 'ok') {
            //                        console.log('settting cost form server.....');
            //                        self.orderData.delivery.cost = response.data.delivery.cost;
            //                        self.orderData.delivery.distance = response.data.delivery.distance;
            //                    } else {
            //                        //@TODO - jesli nie da sie obliczyc ceny
            //                    }
            //                });
        },

        getPartsValueSum: function () {
            if (_.isEmpty(this.orderData.parts)) {
                return "0.00";
            }
            var sum = 0;
            _.forEach(this.orderData.parts, function (item) {
                if (parseFloat(item.ordValue)) {
                }
                var properItemValue = parseFloat(item.ordValue);
                if (!properItemValue) {
                    properItemValue = 0;
                }
                sum += properItemValue;
            });
            if (_.isNaN(sum)) {
                return "0.00";
            }
            return sum.toFixed(2);
        },

        getPartsWeightSum: function () {
            if (_.isEmpty(this.orderData.parts)) {
                return "0.00";
            }
            var sum = 0;
            _.forEach(this.orderData.parts, function (item) {
                if (parseFloat(item.ordWeight)) {
                }
                var properItemValue = parseFloat(item.ordWeight);
                if (!properItemValue) {
                    properItemValue = 0;
                }
                sum += properItemValue;
            });
            if (_.isNaN(sum)) {
                return "0.00";
            }
            return sum.toFixed(2);
        },

        setVendorWarehouse: function (w) {
            this.orderData.warehouse = w;
            this.warehouseError = false;
            this.orderData.delivery.withCarry = 1;
            Event.$emit("toMap", w);
        },

        getCoordForDivision: function (wId) {
            console.log(wId);
        },

        setDeliveryOptionsError: function (v) {
            if (!v) {
                //Event.$emit("orderStep", 4);
                this.getDeliveryCost();
                this.orderStep = 4;
            }
        },

        setCustomerDataError: function (v) {
            console.log("receicve setCustomerDataError");
            this.customerDataError = v;
            if (v == false && this.orderStep == 5) {
                this.createOrder();
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// Hello.vue?7ff9ab74